import React, { useRef } from "react";
import { Modal, Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import kasikornBank from "../../../../assets/images/bankPayment/kasikorn_bank.png";
import scbBank from "../../../../assets/images/bankPayment/scb_bank.png";
import kungthaiBank from "../../../../assets/images/bankPayment/kungthai_bank.png";
import couterService from "../../../../assets/images/bankPayment/couter_service.png";
import lotusService from "../../../../assets/images/bankPayment/lotus_service.png";
import JsBarcode from "jsbarcode";

const underline = (width = 130) => (
  <span
    style={{
      borderBottom: "1px solid #000",
      display: "inline-block",
      minWidth: width,
    }}
  >
    &nbsp;
  </span>
);

// ── BankList ──────────────────────────────────────────────────────────────────
function BankList() {
  const banks = [
    { img: kasikornBank, label: "ธนาคารกสิกรไทย A/C No. (15/20)" },
    { img: scbBank, label: "ธนาคารไทยพาณิชย์ (SCB) A/C No. (15/20)" },
    { img: kungthaiBank, label: "ธนาคารกรุงไทย A/C No. (15/20)" },
    { img: lotusService, label: "เทสโก้ โลตัส และ เทสโก้ โลตัส เอ็กซ์เพรส" },
  ];
  return (
    <table style={{ width: "100%", fontSize: 11, borderCollapse: "collapse" }}>
      <tbody>
        {banks.map((b, i) => (
          <tr key={i} style={{ lineHeight: "22px" }}>
            <td width={20}>
              <input type="checkbox" style={{ margin: 0 }} />
            </td>
            <td width={20}>
              <img
                src={b.img}
                width={16}
                alt=""
                style={{ verticalAlign: "middle" }}
              />
            </td>
            <td style={{ fontSize: 11 }}>{b.label}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── RefBox ────────────────────────────────────────────────────────────────────
function RefBox({ customer, payment, showAmount }) {
  const cL = {
    fontSize: 11,
    fontWeight: "bold",
    whiteSpace: "nowrap",
    padding: "2px 6px 2px 0",
  };
  const cR = { fontSize: 11, padding: "2px 0" };
  const row = (label, value) => (
    <tr key={label}>
      <td style={cL}>{label}</td>
      <td style={cR}>{value}</td>
    </tr>
  );

  const name =
    `${customer.SNAM || ""}${customer.NAME1 || ""} ${customer.NAME2 || ""}`.trim();
  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <tbody>
        {row("สาขา", underline(120))}
        {row("วันที่", underline(120))}
        {row("ชื่อลูกค้า", name || "—")}
        {row("เลขอ้างอิงที่ 1", payment.ref ?? "—")}
        {row("เลขอ้างอิงที่ 2", payment.CODE_CONTNO ?? "—")}
        {showAmount && row("จำนวนเงิน", ` บาท`)}
      </tbody>
    </table>
  );
}

// ── PayInSlip 1 ชุด ───────────────────────────────────────────────────────────
function PayInSlip({
  label,
  customer,
  company,
  payment,
  showAmount,
  mortgage,
}) {
  return (
    <div
      style={{
        border: "1px solid #000",
        background: "#fff",
        color: "#000",
        fontFamily: "Tahoma, Geneva, sans-serif",
        fontSize: 11,
      }}
    >
      {/* ══ HEADER GRAY BLOCK ══ */}
      <div
        style={{
          background: "#d9d9d9",
          borderBottom: "1px solid #000",
          padding: "4px 8px 5px",
        }}
      >
        {/* แถว 1: ชื่อฟอร์ม (ซ้าย) | label (ขวา) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            marginBottom: 2,
          }}
        >
          <div style={{ fontWeight: "bold", fontSize: 12 }}>
            ใบนำฝากชำระเงินค่าสินค้าหรือบริการ (Bill Payment Pay-in-Slip)
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 12,
              marginLeft: 12,
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </div>
        </div>

        {/* แถว 2+: ที่อยู่บริษัท (ซ้าย) | โปรดเก็บ + จำนวน + receipt (ขวา) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* ซ้าย */}
          <div style={{ fontSize: 11, lineHeight: 1.6, flex: 1 }}>
            <div>ที่อยู่ {company.COMP_NM || company.label}</div>
            {(company.COMP_ADR1 || company.address) && (
              <div>{company.COMP_ADR1 || company.address}</div>
            )}
            {company.COMP_ZIP && <div>{company.COMP_ZIP}</div>}
          </div>

          {/* ขวา */}
          <div
            style={{
              fontSize: 11,
              textAlign: "right",
              minWidth: 190,
              flexShrink: 0,
              lineHeight: 1.7,
            }}
          >
            <div>โปรดเก็บค่าธรรมเนียมจากผู้ชำระ</div>
            {label === "สำหรับลูกค้า" && (
              <>
                <div>
                  ค่างวด
                  <span style={{ fontWeight: "bold" }}>
                    {/* {currencyFormat(payment.judgement)} */}
                  </span>
                  &nbsp;บาท
                </div>
                <div>
                  หมายเลขทะเบียนรถ/เลขที่ดิน&nbsp;{mortgage.REGNO ?? "—"}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ══ ธนาคาร (ซ้าย) | Ref (ขวา) ══ */}
      <div style={{ display: "flex", padding: "5px 8px", gap: 8 }}>
        <div style={{ flex: "0 0 53%" }}>
          <BankList />
        </div>
        <div style={{ flex: 1, borderLeft: "1px solid #000", paddingLeft: 8 }}>
          <RefBox
            customer={customer}
            payment={payment}
            showAmount={showAmount}
          />
        </div>
      </div>

      {/* ══ รับชำระด้วยเงินสดเท่านั้น | จำนวนเงิน/AMOUNT ══ */}
      <div
        style={{
          display: "flex",
          borderTop: "1px solid #000",
          borderBottom: "1px solid #000",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "26%",
            background: "#d9d9d9",
            fontWeight: "bold",
            fontSize: 14,
            padding: "3px 8px",
            borderRight: "1px solid #000",
          }}
        >
          รับชำระด้วยเงินสดเท่านั้น
        </div>
        <div
          style={{
            width: "24%",
            background: "#d9d9d9",
            fontWeight: "bold",
            fontSize: 14,
            padding: "3px 6px",
            borderRight: "1px solid #000",
            textAlign: "center",
          }}
        >
          จำนวนเงิน/AMOUNT
        </div>
        <div
          style={{
            width: "39%",
            fontSize: 11,
            padding: "3px 4px",
            borderRight: "1px solid #000",
            textAlign: "center",
          }}
        ></div>
        <div
          style={{
            width: "10%",
            background: "#d9d9d9",
            fontWeight: "bold",
            fontSize: 11,
            padding: "3px 6px",
            borderRight: "1px solid #000",
            textAlign: "center",
          }}
        >
          บาท/BAHT
        </div>
      </div>

      {/* ══ จำนวนเงินตัวอักษร ══ */}
      <div
        style={{
          display: "flex",
          borderTop: "1px solid #000",
          borderBottom: "1px solid #000",
          width: "100%",
        }}
      >
        <div
          style={{
            background: "#d9d9d9",
            fontWeight: "bold",
            fontSize: 14,
            padding: "3px 6px",
            borderRight: "1px solid #000",
            textAlign: "left",
          }}
        >
          จำนวนเงินเป็นตัวอักษร
        </div>
      </div>

      {/* ══ ลายเซ็น ══ */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "4px 8px 6px",
        }}
      >
        <div style={{ fontSize: 11, lineHeight: 2 }}>
          <div>ชื่อผู้นำฝาก&nbsp;{underline(150)}</div>
          <div>โทรศัพท์&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{underline(150)}</div>
        </div>
        <div style={{ fontSize: 11, textAlign: "right", lineHeight: 2 }}>
          <div>สำหรับเจ้าหน้าที่ธนาคาร</div>
          <div>{underline(160)}&nbsp;ผู้รับเงิน</div>
        </div>
      </div>
    </div>
  );
}

const genBarcode = (value, opts = {}) => {
  if (!value) return null;
  try {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(value), {
      format: "CODE128",
      displayValue: false, // true = โชว์ตัวเลขใต้บาร์โค้ด
      margin: 0,
      height: 60,
      width: 2,
      ...opts,
    });
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
};

// ── เปิดหน้าต่างพิมพ์ ─────────────────────────────────────────────────────────
const printHtml = (content) => {
  const win = window.open("", "_blank", "width=900,height=1200");
  win.document.write(`<!DOCTYPE html><html>
    <head>
      <meta charset="utf-8"/>
      <title>ใบนำฝาก Bill Payment Pay-in-Slip</title>
      <style>
        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:Tahoma,Geneva,sans-serif; font-size:11px; background:#fff; padding:8mm 10mm; }
        @page { 
          size:A4; 
          margin:10mm;
          margin-top: 0;      /* ซ่อน header */
          margin-bottom: 0;   /* ซ่อน footer */
        }
        @media print { 
          body { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
        }
      </style>
    </head>
    <body>${content}</body>
  </html>`);
  win.document.close();
  win.focus();

  // รอรูป (QR/บาร์โค้ด) โหลดครบก่อนสั่งพิมพ์
  const imgs = Array.from(win.document.images);
  const waitImgs = Promise.all(
    imgs.map((img) =>
      img.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          }),
    ),
  );
  const timeout = new Promise((resolve) => setTimeout(resolve, 10000));
  Promise.race([waitImgs, timeout]).then(() => {
    setTimeout(() => {
      win.print();
      win.close();
    }, 300);
  });
};

// ── เนื้อหาใบนำฝาก 1 หน้า ─────────────────────────────────────────────────────
function PayInSlipPage({ dataDB2, billPayment, lawsuitData }) {
  const company = billPayment?.company?.[0] || billPayment?.company || {};
  const payment = billPayment?.pay?.[0] || {};
  const customer = dataDB2?.CUSTOMER || {};
  const address =
    customer?.ADDRESS?.find(
      (a) => String(a?.ADDRNO) === String(customer?.MAIN_ADDRNO),
    ) ||
    customer?.ADDRESS?.[0] ||
    {};
  const mortgage = dataDB2?.MORTGAGE || {};

  const ref1 = payment?.ref || "";
  // const ref2 = (payment?.CODE_CONTNO || "").replace(/-/g, "");
  const ref2 = (payment?.CODE_CONTNO || "")
    .replace(/-/g, "")
    .replace(/Q/g, "87"); // เปลี่ยน Q เป็น 87
  const QRCODE_URL =
    "https://asia-east2-fir-express-c1aec.cloudfunctions.net/aa/loans";
  const urlBank = `${QRCODE_URL}/qr/0405559001925/00/${ref1}/${ref2}/000`;
  const urlCtr = `${QRCODE_URL}/qr/0405552000435/00/${ref1}/${ref2}/000`;

  const biller = "0405559001925";

  const barcodeValue = `|${biller}\r${ref1}\r${ref2}\r0`;
  const barcodeImg = genBarcode(barcodeValue);

  const shared = { customer, address, company, payment, mortgage };

  return (
    <>
      {/* ── ข้อมูลลูกค้า (บนสุด นอกกรอบ) ── */}
      <div
        style={{
          marginBottom: 170,
          paddingLeft: 30,
          paddingTop: 30,
          fontSize: 11,
          lineHeight: 1.8,
        }}
      >
        <div>
          <strong>ชื่อลูกค้า</strong>&nbsp;
          {customer.SNAM}
          {customer.NAME1} {customer.NAME2} ({payment?.newContno})
        </div>
        <div>
          ที่อยู่ เลขที่ {address.ADDR1} ต.{address.TUMB} อ.
          {address.AUMPDES} จ.{address.PROVDES}
        </div>
        <div>
          {address.ZIP}&nbsp; <br />
          โทร.{address.TELP}
        </div>
      </div>

      {/* ── ส่วนที่ 1: สำหรับลูกค้า ── */}
      <PayInSlip {...shared} label="สำหรับลูกค้า" showAmount={false} />

      {/* ── เส้นประ ✂ ── */}
      <div
        style={{
          borderTop: "1px dashed #000",
          margin: "8px 0",
          paddingTop: 4,
          textAlign: "right",
          fontSize: 15,
          lineHeight: 1,
        }}
      >
        ✂
      </div>

      {/* ── ส่วนที่ 2: สำหรับธนาคาร ── */}
      <PayInSlip {...shared} label="สำหรับธนาคาร" showAmount={true} />

      {/* ── QR / Barcode ── */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          marginTop: 5,
          padding: "0 4px",
        }}
      >
        <div style={{ flex: "0 0 44%" }}>
          <img src={barcodeImg} alt="barcode" width={"300"} height={"60"} />
          <div style={{ fontSize: 10 }}>{barcodeValue}</div>
        </div>
        {lawsuitData?.COMPANY_ID === 1 || lawsuitData?.COMPANY_ID === 4 ? (
          <div style={{ textAlign: "center" }}>
            <img src={urlBank} alt="QR Bank" width={90} height={90} />
            <div style={{ fontSize: 10, marginTop: 2 }}>ชำระผ่าน ธนาคาร</div>
          </div>
        ) : (
          <div style={{ textAlign: "center" }}>
            <img src={urlCtr} alt="QR Counter" width={90} height={90} />
            <div style={{ fontSize: 10, marginTop: 2 }}>ชำระผ่าน ธนาคาร</div>
          </div>
        )}
      </div>
    </>
  );
}

// ── Modal หลัก ────────────────────────────────────────────────────────────────
export default function PayInSlipModal({
  open,
  onClose,
  dataDB2,
  billPayment,
  lawsuitData,
  items,
}) {
  const printRef = useRef();

  // items = [{ dataDB2, billPayment, lawsuitData }] สำหรับพิมพ์หลายสัญญาพร้อมกัน
  const pages = items?.length ? items : [{ dataDB2, billPayment, lawsuitData }];

  const handlePrint = () => printHtml(printRef.current.innerHTML);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={860}
      title={`🧾 ใบนำฝากชำระเงิน (Bill Payment Pay-in-Slip)${
        pages.length > 1 ? ` — ${pages.length} รายการ` : ""
      }`}
      footer={[
        <Button key="close" onClick={onClose}>
          ปิด
        </Button>,
        <Button
          key="print"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrint}
        >
          พิมพ์ใบเสร็จ
        </Button>,
        <Button
          key="printManual"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={() => {
            window.open(
              "https://storage.googleapis.com/filesupload/lawyer/user/qrCode_acm.pdf",
              "_blank",
            );
          }}
        >
          พิมพ์คู่มือ
        </Button>,
      ]}
      destroyOnHidden
    >
      <div
        ref={printRef}
        style={{ fontFamily: "Tahoma, Geneva, sans-serif", padding: "4px 0" }}
      >
        {pages.map((page, i) => (
          <div
            key={i}
            style={
              i < pages.length - 1
                ? { pageBreakAfter: "always", breakAfter: "page" }
                : undefined
            }
          >
            <PayInSlipPage {...page} />
          </div>
        ))}
      </div>
    </Modal>
  );
}
